import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { pearlCityConfig } from "./data";

export default function PearlCityPage() {
  return <CityPageTemplate config={pearlCityConfig} />;
}